import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Problem, ProblemStatus } from '../../models/Problem';

interface ProblemsState {
  problems: Problem[];
  loading: boolean;
  error: string | null;
}

const initialState: ProblemsState = {
  problems: [],
  loading: false,
  error: null,
};

const problemsSlice = createSlice({
  name: 'problems',
  initialState,
  reducers: {
    setProblems: (state, action: PayloadAction<Problem[]>) => {
      state.problems = action.payload;
    },
    addProblem: (state, action: PayloadAction<Problem>) => {
      state.problems.push(action.payload);
    },
    updateProblem: (state, action: PayloadAction<Problem>) => {
      const index = state.problems.findIndex(p => p.id === action.payload.id);
      if (index !== -1) {
        state.problems[index] = action.payload;
      }
    },
    removeProblem: (state, action: PayloadAction<string>) => {
      state.problems = state.problems.filter(p => p.id !== action.payload);
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    updateProblemStatus: (state, action: PayloadAction<{ id: string; status: ProblemStatus }>) => {
      const problem = state.problems.find(p => p.id === action.payload.id);
      if (problem) {
        problem.status = action.payload.status;
        problem.updatedAt = new Date().toISOString();
      }
    },
  },
});

export const {
  setProblems,
  addProblem,
  updateProblem,
  removeProblem,
  setLoading,
  setError,
  updateProblemStatus,
} = problemsSlice.actions;

export default problemsSlice.reducer;
